import { render, staticRenderFns } from "./CollapseCard.vue?vue&type=template&id=8068dbe6"
import script from "./CollapseCard.vue?vue&type=script&lang=js"
export * from "./CollapseCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/tonumeric/poureux-gestion/projects/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8068dbe6')) {
      api.createRecord('8068dbe6', component.options)
    } else {
      api.reload('8068dbe6', component.options)
    }
    module.hot.accept("./CollapseCard.vue?vue&type=template&id=8068dbe6", function () {
      api.rerender('8068dbe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CollapseCard.vue"
export default component.exports